import React from "react";
import {
  useAccountSubscription,
  useBalanceUpdates,
  useTournamentTicketsUpdates,
  useBetDetailsSubscription,
  useClientInitialization,
  useDeviceUpdateSubscription,
  useDocumentClasses,
  useFavouriteSports,
  useIsMobile,
  useIsNative,
  useMiniCashierDetailsSubscription,
  useMiniCashierInit,
  useNative,
  useSvgLoader,
  useThemeMode,
  useTouchIdSettingsAutoLogin,
  useTouchIdSettingsSubscription,
  useWidgetInitialization,
  useScroll,
  useUserarea,
  useToggleUserarea,
  useKambiMenuSelection,
  useSpectateMenuSelection,
  useAppNoScroll,
  useHtmlElementNoScroll,
  useFeatureStore,
  useDeviceOrientation,
  useClientPageNavigation,
  useToggleHamburgerMenu,
  useToggleAZSports
} from "./hooks";
import {
  useAppearanceSettings,
  useOddsSettings,
  useBiometricsSettings
} from "./components/Settings/hooks";

export const HookLoaderComponent = () => {
  useOddsSettings();
  useAppearanceSettings();
  useDeviceOrientation();
  useAccountSubscription();
  useDeviceUpdateSubscription();
  useDocumentClasses();
  useBalanceUpdates();
  useTournamentTicketsUpdates();
  useSvgLoader();
  useMiniCashierInit();
  useMiniCashierDetailsSubscription();
  useBetDetailsSubscription();
  useThemeMode();
  useIsNative();
  useBiometricsSettings();
  useIsMobile();
  useClientInitialization();
  useWidgetInitialization();
  useKambiMenuSelection();
  useSpectateMenuSelection();
  useNative();
  useTouchIdSettingsSubscription();
  useTouchIdSettingsAutoLogin();
  useFavouriteSports();
  useUserarea();
  useScroll();
  useAppNoScroll();
  useHtmlElementNoScroll();
  useToggleUserarea();
  useClientPageNavigation();
  useFeatureStore();
  useToggleHamburgerMenu();
  useToggleAZSports();
  return null;
};

export default React.memo(HookLoaderComponent);
